import React, {FC} from 'react'

const Toggle: FC = () => <></>

export {Toggle}
